import Rails from '@rails/ujs';

/*
  This module provides easy access to the CSRF token used by Rails.
*/
const csrf = {
  init() {
    this.csrfToken = Rails.csrfToken();
  },

  get token() {
    return this.csrfToken;
  },

  get headerKey() {
    return 'X-CSRF-Token';
  }
};

csrf.init();

export default csrf;
